import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpErrorResponse,
    HttpClient
} from '@angular/common/http';

import {
    Observable,
    throwError
} from 'rxjs';

import {
    catchError,
    switchMap
} from 'rxjs/operators';

import { AuthModalService } from '../../services/auth.modal.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private authModalService: AuthModalService,
        private http: HttpClient
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        const token = sessionStorage.getItem('accessToken');

        // Apply auth only for YOUR backend APIs
        const isApiRequest =
            req.url.startsWith(environment.API_BASE_URL);

        let authReq = req;

        // Only add credentials/token for backend APIs
        if (isApiRequest) {

            authReq = req.clone({
                withCredentials: true
            });

            // Skip token for auth endpoints
            const isAuthRequest =
                req.url.includes('/login') ||
                req.url.includes('/register') ||
                req.url.includes('/refresh');

            // Attach access token
            if (!isAuthRequest && token) {

                authReq = authReq.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`
                    }
                });
            }
        }

        return next.handle(authReq).pipe(

            catchError((error: HttpErrorResponse) => {

                console.log('Interceptor Error:', error);

                // Only handle backend API auth errors
                if (isApiRequest) {

                    // Access token expired
                    if (
                        error.status === 401 &&
                        !req.url.includes('/refresh')
                    ) {

                        return this.handleRefreshToken(
                            authReq,
                            next
                        );
                    }

                    // Forbidden
                    if (error.status === 403) {

                        const token = sessionStorage.getItem('accessToken');

                        // Logout only for logged-in users
                        if (token) {

                            this.logoutUser();
                        }
                    }
                }

                return throwError(() => error);
            })
        );
    }

    private handleRefreshToken(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        return this.http.post<any>(
            `${environment.API_BASE_URL}/auth/refresh`,
            {},
            {
                withCredentials: true
            }
        ).pipe(

            switchMap((response) => {

                const newAccessToken =
                    response.accessToken;

                // Save new access token
                sessionStorage.setItem(
                    'accessToken',
                    newAccessToken
                );

                // Retry original request
                const clonedRequest = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${newAccessToken}`
                    },
                    withCredentials: true
                });

                return next.handle(clonedRequest);
            }),

            catchError((refreshError) => {

                console.log(
                    'Refresh token expired:',
                    refreshError
                );

                this.logoutUser();

                return throwError(() => refreshError);
            })
        );
    }

    private logoutUser(): void {
        sessionStorage.clear();
        localStorage.setItem('userId','');
        localStorage.setItem('role','');
        // localStorage.clear();
        this.authModalService.openLogin();
    }
}